import { Permission } from 'shared'
import { RestoreRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { ProjectCustomField } from 'components/CustomFields/ProjectCustomFieldsContext/types'
import { useCustomFieldPageContext } from '../../CustomFieldPageContext'

export function useRestore(): RestoreRowActionOptions<ProjectCustomField> {
  const { restore } = useCustomFieldPageContext()
  return {
    onRestore: ({ id }) => restore.fn({ variables: { id } }),
    permission: Permission.RemoveRestoreCustomField,
    metadata: ({ deleted, deletedDate, deletedUser }) => ({
      removed: deleted,
      removedBy: deletedUser,
      removedDate: deletedDate,
    }),
  }
}
